// extracted by mini-css-extract-plugin
export default {"rawBody":"styles_rawBody__3IEcA"};